<template>
  <b-modal
    id="switch-program-info-modal"
    ref="switch-program-info-modal"
    body-class="p-10"
    centered
    title="Program Switch Confirmation"
    content-class="p-2"
  >
    <div>
      <p>
        You're currently working on <strong>{{ previous_program_name }}</strong>.<br />
        Would you like to switch to <strong>{{ new_program_name }}</strong> instead?
      </p>
    </div>

    <template #modal-footer>
      <div class="w-100 d-flex">
        <b-button
          class="border border-primary"
          variant="secondary"
          @click="cancel"
        >
          Cancel
        </b-button>
        <b-button
          variant="primary"
          class="ml-auto"
          @click="confirm"
        >
          Confirm
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>

import { BModal, BButton, } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BButton,
  },
  data() {
    return {
      isLoading: false,
    }
  },
  props: {
    previous_program_name: {
      type: String,
      required: true,
    },
    new_program_name: {
      type: String,
      required: true,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    confirm() {
      this.$emit('confirm')
    },
  },
}
</script>

<style scoped>
</style>